export default "__VITE_ASSET__sNaxO4qK__"